import './parts/vietjet.scss';
import { DisplayFormikState, DisplayState, AmeliaCountries } from './parts/helper';
import { PageHeader, PageFooter, TandC, SuccessState, MessageModal } from './parts/com';

import * as dayjs from 'dayjs';

import { isMobile } from 'react-device-detect';
import { Helmet } from "react-helmet";
/* import { testDate } from "./utils"; */

import React from 'react';
import { render } from 'react-dom';
import { withRouter, NavLink } from 'react-router-dom';
import { Formik, Field, setNestedObjectValues } from 'formik';
import * as Yup from 'yup';
import creditCardType, { getTypeInfo, types as CardType } from 'credit-card-type';

import { withTranslation, Trans } from 'react-i18next';

import queryString from 'query-string';

import { ReactComponent as VisaSVG } from './parts/cards/visa.svg';
import { ReactComponent as AmexSVG } from './parts/cards/amex.svg';
import { ReactComponent as McSVG } from './parts/cards/mc.svg';
import { ReactComponent as JcbSVG } from './parts/cards/jcb.svg';
import { ReactComponent as PowerPassLogo } from './parts/powerpasslogo.svg';
/* import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom'; */

import { Container, Row, Col, Modal, Card } from 'react-bootstrap';

const phoneRegExp = /^[\+\d]?(?:[\d-.\s()]*)$/mg;
const phoneRegExpHtml = `[+0-9-() ]+`;
const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%&\^])(?!.*\s).*$/;
const userNameRegExp = /^[a-zA-Z0-9]+([-_]?[a-zA-Z0-9]+)*$/;
const creditCardRegExp = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;

const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)

const appDate = dayjs();
const appDateLimit = appDate.add(6,'years')

const testCardType = (data) => {
	if(data){
	const card = creditCardType(data.toString());
	const validCardTypes = ["american-express","visa","mastercard","jcb"];
	return validCardTypes.includes(card[0].type);
	}
	return true;
}
const getTaxRateByCountry = (p) => {
/* 	if(p === 'VNM') return 0.10;
	return 0 */
	//return 0.10; // this was changed everyone pays 10% tax
	return 0; // now no one pays VAT!
}

const getTaxRateByProvince = (p) => {
	let rate;
	switch (p) {
		case 'NB':
		case 'NL':
		case 'NS':
		case 'PE':
			rate = 0.15;
			break;
		case 'ON':
			rate = 0.13;
			break;
		case 'AB':
		case 'BC':
		case 'MB':
		case 'NT':
		case 'NU':
		case 'QC':
		case 'SK':
		case 'YT':
		case 'WW':
			rate = 0.10;
			break;
		default:
			rate = 0.10;
			break;
	}
	return rate;
};


const CustomInputComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div>
    <input type="text" {...field} {...props} value={field.value.firstNameX} />
    {touched[field.name] &&
      errors[field.name] && <div className="error">{errors[field.name]}</div>}
  </div>
);

class App extends React.Component {
	constructor(props) {
		super(props);
		this.productRef = React.createRef();

		const qp = queryString.parse(this.props.location.search)
		const defaultProduct = qp.pass && this.passTypeDefinition.find(p => p.id.toLowerCase() === qp.pass.toLowerCase())
		const passTypeDefault = defaultProduct || this.passTypeDefinition.sort((a, b) => parseFloat(a.order) - parseFloat(b.order))[0];
		const defaultCountry = "VNM"
		const p = this.calculatePrice(passTypeDefault,getTaxRateByCountry(defaultCountry),{id:'',passTypes:[]});

		const formDataSession = sessionStorage.getItem('formDataSession');
		let defaultFormData;
		if(formDataSession){
			defaultFormData = JSON.parse(formDataSession)
		}else{
			/* defaultFormData = {
				passType:	passTypeDefault.id,
				dirty: false,
				email: 'smccrumb@intelisysaviation.com',
				paxTitle: 'MR',
				firstName: 'steven',
				lastName: 'mccrumb',
				phone: '123456789',
				personalId: 'q3456786543',
				documentType: 'ID',
				city: 'northville',
				country: 'USA',
				birthdayDay: '13',
				birthdayMonth: '04',
				birthdayYear: '1984',
				documentDate: '13',
				documentMonth: '04',
				documentYear: '2000',
				cardHolderName: 'steven mccrumb',
				billingAddress: '358 first street',
				billingCity: 'northville',
				billingCountry: 'USA',
				billingPhone: '123456789',
				billingState: 'MI',
				cardNumber: '4111111111111111',
				expirationMonth: '12',
				expirationYear: '21',
				cvv: '007',
				username: '',
				password: 'TEoVt2@yB@U4Ka',
				postalCode: '48167',
				province: '',
				terms: false,
				subTotal: p.price,
				discountTotal: p.discountTotal,
				originalTotal: p.originalTotal,
				taxesTotal: p.taxTotal,
				paymentTotal: p.paymentPrice,
				userKey: '',
				referredById: qp['referral-id'] || '',
				referredByPhone: qp['referral-phone'] || '',
				referredByEmail: qp['referral-email'] || '',
				referredByFullname: qp['referral-name'] || '',
				href: window.location.href || '',
				usernamePrefix: 'SKY-',
				discountCode: {id:'', passTypes: []}
			} */
			defaultFormData = {
				passType:	passTypeDefault.id,
				dirty: false,
				email: '',
				paxTitle: 'MR',
				firstName: '',
				lastName: '',
				phone: '',
				personalId: '',
				documentType: '',
				city: '',
				country: '',
				birthdayDay: '',
				birthdayMonth: '',
				birthdayYear: '',
				documentDate: '',
				documentMonth: '',
				documentYear: '',
				cardHolderName: '',
				billingAddress: '',
				billingCity: '',
				billingCountry: 'VNM',
				billingPhone: '',
				billingState: '',
				cardNumber: '',
				expirationMonth: '',
				expirationYear: '',
				cvv: '',
				username: '',
				password: '',
				postalCode: '',
				province: '',
				terms: false,
				subTotal: p.price,
				discountTotal: p.discountTotal,
				originalTotal: p.originalTotal,
				taxesTotal: p.taxTotal,
				paymentTotal: p.paymentPrice,
				userKey: '',
				referredById: qp['referral-id'] || '',
				referredByPhone: qp['referral-phone'] || '',
				referredByEmail: qp['referral-email'] || '',
				referredByFullname: qp['referral-name'] || '',
				href: window.location.href || '',
				usernamePrefix: 'SKY-',
				discountCode: {id:'', passTypes: []}
			}
		}

		this.state = {
			data: null,
			modal: false,
			errorMessage: null,
			lang: this.props.match.params.lang || 'en',
			/* success: true,
			passType: defaultProduct || this.passTypeDefinition[0],
			userLogonName: 'SKY-TESTUSERNAME',
			traveler: 'MCCRUMB.STEVEN MICHAEL',
			serialNumber: 'T7oHxU@R2U%cbi', */
			success: null,
			passType: defaultProduct || this.passTypeDefinition.sort((a, b) => parseFloat(a.order) - parseFloat(b.order))[0],
			userLogonName: '',
			serialNumber: '',
			traveler: '',
			showReferral: qp && qp.show && qp.show == "referral",
			queryParams: qp,
			hideReferralFields: qp['referral-id'] || false,
			disableReferralFields: qp['referral-name'] || qp['referral-phone'] || qp['referral-email'] || qp['referral-id'] || false,
			discountCodeList: [],
			discountCode: {id:'', passTypes: []},
			submittedData: defaultFormData
		};
		this.toggle = this.toggle.bind(this);
		this.focusChange = this.focusChange.bind(this);

		this.props.i18n.changeLanguage(this.props.match.params.lang);
		
  }

  focusChange(e) {
    if (e.target.value.length >= e.target.getAttribute("maxlength")) {
			if(e.target.id == "birthdayMonth") document.getElementById("birthdayYear").focus()
			if(e.target.id == "birthdayDay") document.getElementById("birthdayMonth").focus()
			if(e.target.id == "documentMonth") document.getElementById("documentYear").focus()
			if(e.target.id == "documentDate") document.getElementById("documentMonth").focus()
			if(e.target.id == "expirationMonth") document.getElementById("expirationYear").focus()
			if(e.target.id == "expirationYear") document.getElementById("cvv").focus()
    }
  }

	toggle() {
		this.setState({
			success: null
			/* modal: !this.state.modal */
		});
	}

	async fetchAvailableDiscounts(updatedValues){
		
		try {
			let response = await fetch(
				`${process.env.REACT_APP_DISCOUNT_API_URL}`,
				{
					method: 'GET',
					headers: { 'Content-Type': 'application/json' }
				}
				);
				let data = await response.json();
				if(data.length){
					let x = (updatedValues) ? {...updatedValues} : {...this.state.submittedData};
					const pass = this.passTypeDefinition.find(ptd => ptd.id === x.passType)

					this.setState({discountCodeList: data, discountCode: data[0]},()=>{
						const highestDiscountForProduct = this.matchHighestDiscountToProduct(pass.id)
						const p = this.calculatePrice(pass,getTaxRateByCountry(x.billingCountry),highestDiscountForProduct);
					

						x.discountCode = (this.checkDiscountForProduct(pass,highestDiscountForProduct) ? highestDiscountForProduct : {});
						x.subTotal = p.price
						x.discountTotal= p.discountTotal
						x.originalTotal= p.originalTotal
						x.taxesTotal= p.taxTotal
						x.paymentTotal= p.paymentPrice

						this.setState({submittedData: x});
					})
					
			}else{
				let x = (updatedValues) ? {...updatedValues} : {...this.state.submittedData};
					const p = this.calculatePrice(this.passTypeDefinition.find(ptd => ptd.id === x.passType),getTaxRateByCountry(x.billingCountry),data[0]);
					x.discountCode = ''
					x.subTotal = p.price
					x.discountTotal= p.discountTotal
					x.originalTotal= p.originalTotal
					x.taxesTotal= p.taxTotal
					x.paymentTotal= p.paymentPrice

				this.setState({discountCode: {id:'',passTypes:[]},submittedData: x},()=>{
				})
			}
		} catch(e){
			console.log(e)
		}

	}

	async fetchTanC(updatedValues){
		
		try {
			let response = await fetch(
				`https://powerpass.vietjetair.com/api/TermAndCondition?lang=${this.state.lang}`,
				{
					method: 'GET',
					headers: { 'Content-Type': 'application/json' }
				}
				);
				let tAndCData = await response.json();
				if(tAndCData){
					this.setState({data: tAndCData.Content})
				}
		} catch(e){
			/* console.log(e) */
		}

	}

	async componentDidMount() {
		this.fetchAvailableDiscounts()
		this.fetchTanC()
	}

	matchHighestDiscountToProduct = (id) => {
		const {discountCodeList} = this.state;
		const discountSearch = discountCodeList.reduce((acc,curr)=>{
			if(curr.passTypes.find(pt => pt === id)) acc.push(curr);
			return acc;
		},[]);

		discountSearch.sort((a, b) => parseFloat(b.percentage) - parseFloat(a.percentage)); // order discounts from higest to lowest. 

		if(!discountSearch.length) return null;

		return discountSearch[0]; // grab the first discount code 
	}

	getProductPriceWithDiscount = (id) => {
		const discountCode = this.matchHighestDiscountToProduct(id);
		if(!discountCode) return 0;
		const passValue = this.passTypeDefinition.find(ptd => ptd.id === id).value
		return passValue * (discountCode.percentage/100)
	}

	calculatePrice = (base,provinceRate,discountCode) => {
		let price = parseFloat(base.value);
		const discountTotal = (discountCode && discountCode.id && this.checkDiscountForProduct(base,discountCode)) ? price * (discountCode.percentage/100) : 0;
		let subTotal = price - discountTotal;
		const taxTotal = subTotal * provinceRate; // this will have to be dynamic based on where they are
		const paymentPrice = subTotal + taxTotal;
		return { 	
							originalTotal: price.toLocaleString('en-VI',{minimumFractionDigits: 0, maximumFractionDigits: 0}), 
							price: subTotal.toLocaleString('en-VI',{minimumFractionDigits: 0, maximumFractionDigits: 0}), 
							discountTotal: discountTotal.toLocaleString('en-VI',{minimumFractionDigits: 0, maximumFractionDigits: 0}), 
							taxTotal: taxTotal.toLocaleString('en-VI',{minimumFractionDigits: 0, maximumFractionDigits: 0}), 
							paymentPrice: paymentPrice.toLocaleString('en-VI',{minimumFractionDigits: 0, maximumFractionDigits: 0})};
	}
	
	onSelectChange = (e, setFieldValue, rate) => {
		//const product = e.dataset.passValue;
		const product = this.passTypeDefinition.find(ptd => ptd.id === e)
		//const product = this.productRef.current.selectedOptions[0].dataset.passValue;
		//const product = e.selectedOptions[0].dataset.passValue;
		//console.log(e.selectedOptions[0].dataset.passValue)
		//console.log(this.productRef.current.selectedOptions[0].dataset.passValue)
		const highestDiscountForProduct = this.matchHighestDiscountToProduct(e);
		
		setFieldValue('discountCode', (this.checkDiscountForProduct(product,highestDiscountForProduct) ? highestDiscountForProduct : ''), false);


		const calculated = this.calculatePrice(product,rate,highestDiscountForProduct);
		setFieldValue('subTotal', calculated.price, false);
		setFieldValue('originalTotal', calculated.originalTotal, false);
		setFieldValue('discountTotal', calculated.discountTotal, false);
		setFieldValue('taxesTotal', calculated.taxTotal, false);
		setFieldValue('paymentTotal', calculated.paymentPrice, false);
	}

	checkDiscountForProduct = (pass,discount) => {
		if(!discount?.passTypes) return false;
		return discount.passTypes.includes(pass.id)
	}


	changeLanguage = nextLang => {
		const { children, i18n, t, history, match } = this.props;
    const newUrl = `${match.path.replace(':lang',nextLang)}`;
    history.push(newUrl);
		i18n.changeLanguage(nextLang);
	};
	
  handleClickSelectLanguage = (lang) => {
		this.changeLanguage(lang);
		this.setState({lang:lang},()=>{this.fetchTanC();})
	};

	streamingFormUpdate = async (setValues,setFieldValue,values) => {
		await this.fetchAvailableDiscounts();
		setValues(values,false)
		this.onSelectChange(values.passType,setFieldValue,getTaxRateByCountry(values.billingCountry))
	}
	
	passTypeDefinition = [
		//{"id" : "SKY6", name: this.props.t('sections.packageType.products.SKY6'), value: 8999000, order: 30},
		{"id" : "SKY12", name: this.props.t('sections.packageType.products.SKY12'), value: 19999000, order: 20},
		{"id" : "SkyBoss", name: this.props.t('sections.packageType.products.SkyBoss'), value: 74999000, order: 10}
		//{"id" : "SkyBoss-H1", name: this.props.t('sections.packageType.products.SkyBoss-H1'), value: 68999000, order: 10}
	]
	
	render() {
		const showReferral = this.state.showReferral

		const {t,i18n} = this.props

		return (
			<div className="app">
				<Helmet>
					<meta property="og:site_name" content="powerpass.vietjetair.com"/>
					<meta property="og:rich_attachment" content="true"/>
					<meta property="og:type" content="article"/>
					<meta property="og:image" itemprop="thumbnailUrl" content="https://powerpass.vietjetair.com/Themes/Frontend/skyflyer/assets/powerpass_share.jpg"/>
					<meta property="og:image:width" content="800"/>
					<meta property="og:image:height" content="354"/>
					<meta content={t('html.meta.title')} itemprop="headline" property="og:title"/>
					<meta content={t('html.meta.description')} itemprop="description" property="og:description"/>
					<meta name="twitter:card" value="summary"/>
					<meta name="twitter:title" content={t('html.meta.title')}/>
					<meta name="twitter:description" content={t('html.meta.description')}/>
					<meta name="twitter:image" content="https://powerpass.vietjetair.com/Themes/Frontend/skyflyer/assets/powerpass_share.jpg"/>
					<meta name="twitter:site" content="@powerpass"/>
					<meta property="og:url" content={t('html.meta.url')} />
					<meta property="og:title" content={t('html.meta.title')} />
					<meta property="og:image" content="https://powerpass.vietjetair.com/Themes/Frontend/skyflyer/assets/powerpass_share.jpg" />
					<meta property="og:description" content={t('html.meta.description')} /> 
        </Helmet>
					
				<PageHeader handleClickSelectLanguage={this.handleClickSelectLanguage} lang={this.state.lang} t={t}/>

					{!this.state.success ? (
					<Formik
						enableReinitialize={true}
						initialValues={this.state.submittedData}
						onSubmit={async (values, { setSubmitting, setFieldValue, resetForm }) => {
							/* setSubmitting(true);
							await new Promise((resolve) => setTimeout(resolve, 5000));
							return false; */
							// add language to payload
							values.lang = this.state.lang || this.props.match.params.lang || 'en';
							const discountObject = values.discountCode;
							values.discountCode = values.discountCode.id;

							let safeData = {...values}
									safeData.cardNumber = "";
									safeData.expirationMonth = "";
									safeData.expirationYear = "";
									safeData.cvv = "";

							setSubmitting(true);
							try {
								let response = await fetch(
									`${process.env.REACT_APP_API_URL}/process`,
									{
										method: 'POST',
										headers: { 'Content-Type': 'application/json' },
										body: JSON.stringify(values)
									}
								);
								let data = await response.json();
								if (data.status === 'approved') {
									values.discount = discountObject;
									setSubmitting(false);
									this.setState({
										success: true,
										/* passType: data.response.voucher.voucherType.name, */
										userLogonName: data.response.user.userLogonName,
										traveler: data.response.user.name,
										serialNumber: data.response.voucherAssign.serialNumber,
										submittedData: values
									});
									window.scrollTo(0, 0);
									sessionStorage.removeItem('formDataSession');
									
								} else {
									setSubmitting(false);
									if(data.response.err.method == "postPaymentToCompany"){
										setFieldValue('userKey',data.response.err.data.userKey,false)
										safeData.userKey = data.response.err.data.userKey
									}
									
									sessionStorage.setItem('formDataSession',JSON.stringify(safeData));
									this.fetchAvailableDiscounts(values)
									this.setState({ errorMessage: data.response.err.message, success: false });
									
								}
							} catch (error) {
								setSubmitting(false);
								sessionStorage.setItem('formDataSession',JSON.stringify(safeData));
								this.setState({ errorMessage: JSON.stringify(error), success: false });
							}
						}}
						validationSchema={Yup.object().shape({
							email: Yup.string().email(t('fields.email.errors.invalid')).required(t('fields.email.errors.required')),
							firstName: Yup.string().required(t('fields.name.errors.required')),
							lastName: Yup.string().required(t('fields.surname.errors.required')),
							personalId: Yup.string().required(t('fields.personalId.errors.required')),
							billingAddress: Yup.string().required(t('fields.billingAddress.errors.required')),
							billingCity: Yup.string().required(t('fields.billingCity.errors.required')),
							terms: Yup.bool().oneOf([ true ], t('fields.terms.errors.required')),
							username: Yup.string()
								.matches(userNameRegExp, t('fields.username.errors.format'))
								.max(20 - this.state.submittedData.usernamePrefix.length, t('fields.username.errors.length'))
								.required(t('fields.username.errors.required')),
							password: Yup.string().required(t('fields.password.errors.required'))
								.min(8, t('fields.password.errors.length'))
								.max(20, t('fields.password.errors.max'))
								.matches(passwordRegex, t('fields.password.errors.matches')),
							phone: Yup.string().matches(phoneRegExp, t('fields.phone.errors.invalid'))
								.required(t('fields.phone.errors.required')),
							referredByPhone: Yup.string().matches(phoneRegExp, t('fields.phone.errors.invalid')),
							referredByEmail: Yup.string().email(t('fields.referredByEmail.errors.invalid')),
							referredByFullname: Yup.string()
							.test('check_supporting_referral_fields_start', t('fields.referredByFullname.errors.required'), function(value){
								const { referredByPhone, referredByEmail } = this.parent;
								if((referredByEmail || referredByPhone) && (!value)) return false
								return true
							})
							.test('check_supporting_referral_fields', t('fields.referredByFullname.errors.requireAdditional'), function(value){
								const { referredByPhone, referredByEmail } = this.parent;
								
								if((!referredByEmail) && (!referredByPhone) && (!value)) return true
								if((referredByEmail && referredByEmail.length) || (referredByPhone && referredByPhone.length)) {
									return true
								}else{
									return false
								}
							}),
							billingPhone: Yup.string().matches(phoneRegExp, t('fields.phone.errors.invalid'))
								.required(t('fields.phone.errors.required')),
							paxTitle: Yup.string().notOneOf([ 'U/A' ],t('fields.title.errors.required')).required(t('fields.title.errors.required')),
							documentType: Yup.string().notOneOf([ 'U/A' ],t('fields.documentType.errors.required')).required(t('fields.documentType.errors.required')),
							billingCountry: Yup.string().notOneOf([ 'U/A' ],t('fields.billingCountry.errors.required')).required(t('fields.billingCountry.errors.required')),
							country: Yup.string().notOneOf([ 'U/A' ],t('fields.country.errors.required')).required(t('fields.country.errors.required')),
							billingState: Yup.string().notOneOf([ '','U/A' ]).required(t('fields.residence.errors.required')),
							passType: Yup.string().notOneOf([ '' ]).required(t('fields.passType.errors.required')),
							documentDate: Yup.number()
								.required(t('fields.documentDate.day.errors.required'))
								.max(31, t('fields.documentDate.day.errors.max'))
								.min(1, t('fields.documentDate.day.errors.min')),
							documentMonth: Yup.number()
								.required(t('fields.documentDate.month.errors.required'))
								.max(12, t('fields.documentDate.month.errors.max'))
								.min(1, t('fields.documentDate.month.errors.min')),
							documentYear: Yup.number()
							.test(
								"check_docdate",
								t('fields.documentDate.year.errors.test'),
								function(value) {
									const { birthdayDay, birthdayMonth, birthdayYear, documentDate, documentMonth } = this.parent;
									let bday = new Date(birthdayYear, birthdayMonth-1, birthdayDay,0,0,0).getTime()
			
									let docDate = new Date(value,documentMonth-1,documentDate,0,0,0).getTime()
									const todayCompare = new Date().getTime()
									if(docDate >= bday && docDate <= todayCompare){
										return true
									}else{
										return false
									}
								}
							)
								.min(1900, t('fields.birthday.year.errors.min'))
								.required(t('fields.birthday.year.errors.required')),
							birthdayDay: Yup.number()
								.required(t('fields.birthday.day.errors.required'))
								.max(31, t('fields.birthday.day.errors.max'))
								.min(1, t('fields.birthday.day.errors.min')),
							birthdayMonth: Yup.number()
								.required(t('fields.birthday.month.errors.required'))
								.max(12, t('fields.birthday.month.errors.max'))
								.min(1, t('fields.birthday.month.errors.min')),
							birthdayYear: Yup.number()
								.test(
									"check_birthday",
									t('fields.birthday.year.errors.test'),
									function(value) {
										const { birthdayDay, birthdayMonth } = this.parent;
										let today = dayjs()
										let bday = new Date(value, birthdayMonth-1, birthdayDay,0,0,0)
										let born = dayjs(bday)
										if(born.isBefore(today.subtract(2,'years'))){
											return true
										}else{
											return false
										}
									}
								)
								.min(1900, t('fields.birthday.year.errors.min'))
								.required(t('fields.birthday.year.errors.required')),
							cardHolderName: Yup.string().required(t('fields.cardHolderName.errors.required')),
							cardNumber: Yup.string()
								.test(
									"check_card_brand",
									t('fields.cardNumber.errors.test'),
									function(value) {
										return testCardType(value);
									}
								)
								.matches(creditCardRegExp, t('fields.cardNumber.errors.invalid'))
								.required(t('fields.cardNumber.errors.required')),
							cvv: Yup.string()
								.required(t('fields.cvv.errors.required'))
								.matches(/[0-9]{3,4}$/, t('fields.cvv.errors.matches')),
							expirationMonth: Yup.number()
								.required(t('fields.expirationDate.month.errors.required'))
								.max(12, t('fields.expirationDate.month.errors.max'))
								.min(1, t('fields.expirationDate.month.errors.min')),
								expirationYear: Yup.number()
								.test(
									"check_exp_month_year",
									t('fields.expirationDate.year.errors.test'),
									function(value) {
										const today = dayjs();
										const { expirationMonth } = this.parent;
										const cardDate = dayjs(`20${value}-${expirationMonth}-01`) //good for another 79 years...
										const limitYear = appDateLimit

										if(cardDate.isSameOrAfter(today, 'month') && cardDate.isSameOrBefore(limitYear, 'month')) return true;
										return false;
									}
								)
								.required(t('fields.expirationDate.year.errors.required'))
								.max(parseInt(appDateLimit.year().toString().slice(-2)), t('fields.expirationDate.year.errors.max'))
								.min(parseInt(appDate.year().toString().slice(-2)), t('fields.expirationDate.year.errors.min'))
						})}
					>
						{(props) => {
							const {
								values,
								touched,
								errors,
								dirty,
								isSubmitting,
								handleChange,
								handleBlur,
								handleSubmit,
								handleReset,
								setFieldValue,
								children
							} = props;
							return (
								<Container>
									<form onSubmit={handleSubmit}>
										<h1 className="mt-5">{t('sections.page.title')}</h1>
										<div className="pax-warning">{t('sections.page.paxWarning')}</div>
										<h2 className="mt-5">{t('sections.passengerDetails.title')}</h2>
										<div className="email-warning">{t('sections.page.emailWarning')}</div>
										<Row className="mt-3 justify-content-md-center">
											<Col xs={12} md={1}>
											<div className="field">
												
												<Field
													as="select"
													name="paxTitle"
													value={values.paxTitle}
													onChange={(ev) => {
														handleChange(ev);
													}}
													onBlur={handleBlur}
													style={{ display: 'block' }}
													className={
														errors.paxTitle && touched.paxTitle ? (
															'control-select error has-error form-control'
														) : (
															`control-select form-control ${(touched.paxTitle) ? 'touched' : ''}`
														)
													}
												>
													<option value="U/A" defaultValue>{t('fields.title.label')}</option>
													<option value="MR">{t('fields.title.options.MR')}</option>
													<option value="MS">{t('fields.title.options.MS')}</option>
													<option value="CH">{t('fields.title.options.CH')}</option>
													
												</Field>
												<label htmlFor="paxTitle" style={{ display: 'block' }}>
												{t('fields.title.label')}*
												</label>
												</div>

												{errors.paxTitle &&
												touched.paxTitle && (
													<div className="input-feedback">{errors.paxTitle}</div>
												)}
											</Col>
											<Col xs={12} md={3}>
											<div className="field">
												<input
													id="lastName"
													placeholder={t('fields.surname.placeholder')}
													type="text"
													value={values.lastName}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.lastName && touched.lastName ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="lastName" style={{ display: 'block' }}>
												{t('fields.surname.label')}*
												</label>
												</div>
												{errors.lastName &&
												touched.lastName && (
													<div className="input-feedback">{errors.lastName}</div>
												)}
											</Col>
											<Col xs={12} md={3}>
												<div className="field">
												<input
													id="firstName"
													placeholder={t('fields.name.placeholder')}
													type="text"
													value={values.firstName}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.firstName && touched.firstName ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="firstName" style={{ display: 'block' }}>
												{ t('fields.name.label') }*
												</label>
												</div>
												{errors.firstName &&
												touched.firstName && (
													<div className="input-feedback">{errors.firstName}</div>
												)}
											</Col>
											<Col xs={12} md={3}>
											<div className="field">
												
												<input
													id="email"
													placeholder={t('fields.email.placeholder')}
													type="email"
													value={values.email}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.email && touched.email ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="email" style={{ display: 'block' }}>
												{t('fields.email.label')}*
												</label>
												</div>
												{errors.email &&
												touched.email && <div className="input-feedback">{errors.email}</div>}
											</Col>
											<Col xs={12} md={2}>
											<div className="field">
											
												<input
													id="phone"
													placeholder={t('fields.phone.placeholder')}
													type="tel"
													pattern={phoneRegExpHtml}
													value={values.phone}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.phone && touched.phone ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
													<label htmlFor="phone" style={{ display: 'block' }}>
													{t('fields.phone.label')}*
												</label>
												</div>
												{errors.phone &&
												touched.phone && <div className="input-feedback">{errors.phone}</div>}
											</Col>
										</Row>
										
										<Row className="mt-3 justify-content-md-center">
											<Col xs={12} md={3}>
												
												<Row className="no-gutters">
													
													<Col className="date-collapse">
													<div className="field main">
														
														<input
															id="birthdayDay"
															placeholder={t('fields.birthday.day.placeholder')}
															type="number"
															pattern="[0-9]*"
															maxLength="2"
                							onInput={e => this.focusChange(e)}
															value={values.birthdayDay}
															onChange={handleChange}
															onBlur={(ev) => {
																handleBlur(ev)
																if(!ev.target.value) ev.target.parentNode.parentNode.classList.remove("focused")
															}}
															onFocus={(ev) => {
																ev.target.parentNode.parentNode.classList.add("focused")
															}}
															className={
																errors.birthdayDay && touched.birthdayDay ? (
																	'text-input error has-error form-control'
																) : (
																	'text-input form-control'
																)
															}
														/>
														<label htmlFor="birthdayDay" style={{ display: 'block' }}>
														{t('fields.birthday.label')}*
												</label>
													</div>
													
													<div className="fieldH sibling">
														<input
															id="birthdayMonth"
															placeholder={t('fields.birthday.month.placeholder')}
															type="number"
															pattern="[0-9]*"
															maxLength="2"
                							onInput={e => this.focusChange(e)}
															value={values.birthdayMonth}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																errors.birthdayMonth && touched.birthdayMonth ? (
																	'text-input error has-error form-control'
																) : (
																	'text-input form-control'
																)
															}
														/>
														<label htmlFor="birthdayMonth" style={{ visibility: 'hidden'}}>{t('fields.birthday.month.placeholder')}</label>
														</div>
													
													<div className="fieldH sibling">
														<input
															id="birthdayYear"
															placeholder={t('fields.birthday.year.placeholder')}
															type="number"
															pattern="[0-9]*"
															maxLength="4"
															value={values.birthdayYear}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																errors.birthdayYear && touched.birthdayYear ? (
																	'text-input error has-error form-control'
																) : (
																	'text-input form-control'
																)
															}
														/>
														<label htmlFor="birthdayYear" style={{ visibility: 'hidden'}}>{t('fields.birthday.year.placeholder')}</label>
														</div>
													</Col>
												</Row>
												<div>
												{errors.birthdayDay &&
													touched.birthdayDay && (
														<div className="input-feedback">{errors.birthdayDay}</div>
													)}
													{errors.birthdayMonth &&
													touched.birthdayMonth && (
														<div className="input-feedback">{errors.birthdayMonth}</div>
													)}
													{errors.birthdayYear &&
													touched.birthdayYear && (
														<div className="input-feedback">{errors.birthdayYear}</div>
													)}
												</div>
											</Col>
											<Col xs={12} md={2}>
											<div className="field">
												
												<Field
													as="select"
													name="documentType"
													value={values.documentType}
													onChange={(ev) => {
														handleChange(ev);
													}}
													onBlur={handleBlur}
													style={{ display: 'block' }}
													className={
														errors.documentType && touched.documentType ? (
															'control-select error has-error form-control'
														) : (
															`control-select form-control ${(touched.documentType) ? 'touched' : ''}`
														)
													}
												>
													<option value="U/A" defaultValue>{t('fields.documentType.label')}</option>
													<option value="ID">{t('fields.documentType.options.ID')}</option>
													<option value="PP">{t('fields.documentType.options.PP')}</option>
													<option value="DL">{t('fields.documentType.options.DL')}</option>
													<option value="BC">{t('fields.documentType.options.BC')}</option>
													
												</Field>
												<label htmlFor="documentType" style={{ display: 'block' }}>
												{t('fields.documentType.label')}*
												</label>
												</div>

												{errors.documentType &&
												touched.documentType && (
													<div className="input-feedback">{errors.documentType}</div>
												)}
											</Col>	
											<Col xs={12} md={2}>
											<div className="field">
												
												<input
													id="personalId"
													placeholder={t('fields.personalId.placeholder')}
													type="text"
													value={values.personalId}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.personalId && touched.personalId ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="personalId" style={{ display: 'block' }}>
												{t('fields.personalId.label')}*
												</label>
												</div>
												{errors.personalId &&
												touched.personalId && (
													<div className="input-feedback">{errors.personalId}</div>
												)}
											</Col>	
											<Col xs={12} md={2}>
											<div className="field">
												
												<Field
													as="select"
													name="country"
													value={values.country}
													onChange={(ev) => {
														handleChange(ev);
													}}
													onBlur={handleBlur}
													style={{ display: 'block' }}
													className={
														errors.country && touched.country ? (
															'control-select error has-error form-control'
														) : (
															`control-select form-control ${(touched.country) ? 'touched' : ''}`
														)
													}
												>
													<option value="U/A" defaultValue>{t('fields.country.label')}</option>
													{AmeliaCountries.map(c => (
														<option key={c.code} value={c.code}>{c.name}</option>
													))}
												</Field>

												<label htmlFor="country" style={{ display: 'block' }}>
												{t('fields.country.label')}*
												</label>
												</div>

												{errors.country &&
												touched.country && (
													<div className="input-feedback">{errors.country}</div>
												)}
											</Col>
											<Col xs={12} md={3}>
												
												<Row className="no-gutters">
													
													<Col className="date-collapse">
													<div className="field main">
														
														<input
															id="documentDate"
															placeholder={t('fields.documentDate.day.placeholder')}
															type="number"
															pattern="[0-9]*"
															maxLength="2"
                							onInput={e => this.focusChange(e)}
															value={values.documentDate}
															onChange={handleChange}
															onFocus={(ev) => {
																ev.target.parentNode.parentNode.classList.add("focused")
															}}
															onBlur={(ev) => {
																handleBlur(ev)
																if(!ev.target.value) ev.target.parentNode.parentNode.classList.remove("focused")
															}}
															className={
																errors.documentDate && touched.documentDate ? (
																	'text-input error has-error form-control'
																) : (
																	'text-input form-control'
																)
															}
														/>
														<label htmlFor="documentDate" style={{ display: 'block' }}>
														{t('fields.documentDate.label')}*
												</label>
													</div>
													
													<div className="fieldH sibling">
														<input
															id="documentMonth"
															placeholder={t('fields.documentDate.month.placeholder')}
															type="number"
															pattern="[0-9]*"
															maxLength="2"
                							onInput={e => this.focusChange(e)}
															value={values.documentMonth}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																errors.documentMonth && touched.documentMonth ? (
																	'text-input error has-error form-control'
																) : (
																	'text-input form-control'
																)
															}
														/>
														<label htmlFor="documentMonth" style={{ visibility: 'hidden'}}>{t('fields.documentDate.month.placeholder')}</label>
														</div>
													
													<div className="fieldH sibling">
														<input
															id="documentYear"
															placeholder={t('fields.documentDate.year.placeholder')}
															type="number"
															pattern="[0-9]*"
															maxLength="4"
															value={values.documentYear}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																errors.documentYear && touched.documentYear ? (
																	'text-input error has-error form-control'
																) : (
																	'text-input form-control'
																)
															}
														/>
														<label htmlFor="documentYear" style={{ visibility: 'hidden'}}>{t('fields.documentDate.year.placeholder')}</label>
														</div>
													</Col>
												</Row>
												<div>
													
													{errors.documentDate &&
													touched.documentDate && (
														<div className="input-feedback">{errors.documentDate}</div>
													)}
													{errors.documentMonth &&
													touched.documentMonth && (
														<div className="input-feedback">{errors.documentMonth}</div>
													)}
													{errors.documentYear &&
													touched.documentYear && (
														<div className="input-feedback">{errors.documentYear}</div>
													)}
												</div>
											</Col>	
										</Row>

										<h2 className="mt-5">{t('sections.accessDetails.title')}</h2>
										<Row className="mt-3 justify-content-md-center">
											<Col className={'username'}>
											<div className="field">
												
												<span className={"prefix"}>{this.state.submittedData.usernamePrefix}</span>
												<input
													id="username"
													placeholder=" "
													type="text"
													value={values.username}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.username && touched.username ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="username" style={{ display: 'block' }}>
												{t('fields.username.label')}*
												</label>
												</div>
												{errors.username &&
												touched.username && (
													<div className="input-feedback">{errors.username}</div>
												)}
											</Col>
											<Col>
											<div className="field">
												
												<input
													id="password"
													placeholder={t('fields.password.placeholder')}
													type="password"
													value={values.password}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.password && touched.password ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="password" style={{ display: 'block' }}>
												{t('fields.password.label')}*
												</label>
												</div>
												{errors.password &&
												touched.password && (
													<div className="input-feedback">{errors.password}</div>
												)}
											</Col>
										</Row>
										
										<h2 className="mt-5">{t('sections.packageType.title')}</h2>
										<Row className="mt-3 justify-content-md-left">
											<Col xs={12} sm={12} md={10}>
												{/* <label htmlFor="passType" style={{ display: 'block' }}>
													Go Travel Pass
												</label>
												
												<Field
													as="select"
													innerRef={this.productRef}
													name="passType"
													value={values.passType}
													onChange={(ev) => {
														handleChange(ev);
														let rate = getTaxRateByProvince(values.province)
														this.onSelectChange(ev.target, setFieldValue, rate);
													}}
													onBlur={handleBlur}
													style={{ display: 'block' }}
													className={
														errors.passType && touched.passType ? (
															'control-select error has-error form-control'
														) : (
															'control-select form-control'
														)
													}
												>
													{passTypeDefinition.map(ptd => (
														<option key={ptd.id} value={ptd.id} data-pass-value={ptd.value}>{ptd.name} - {ptd.value}đ</option>
													))}
												
												</Field> */}
													<Row className="mt-3 row-cols-1 row-cols-sm-2 justify-content-md-start card-select">
													{this.passTypeDefinition.sort((a, b) => parseFloat(a.order) - parseFloat(b.order)).map((ptd,i) => {
														const productDiscount = this.getProductPriceWithDiscount(ptd.id);
														const priceWithDiscount = ptd.value - productDiscount;
														return(
														<Col key={ptd.id} className="mb-3">
															<label className={`card-label ${(values.passType === ptd.id) ? ' selected' : ''}`} htmlFor={`${ptd.id}-${i}`}>
																<Card>
																<Card.Header>
																	<PowerPassLogo/><span>{ptd.id}</span>
																</Card.Header>
																	<Card.Body>
																		{productDiscount != 0 && (<div className="discount"><span>{priceWithDiscount.toLocaleString('en-VI')}</span><small>VND<br/>(*)</small></div>)}
																		<div className={`${(productDiscount) ? 'original' : 'full'}`}><span>{ptd.value.toLocaleString('en-VI')}</span><small>VND<br/>(*)</small></div>
																	</Card.Body>
																	<Card.Footer dangerouslySetInnerHTML={{__html: t(`fields.passType.options.${ptd.id}`,{validity_end_date: '31/10/2022'})}}/>
																</Card>
															</label>
															<input type="radio" name="passType" id={`${ptd.id}-${i}`} value={ptd.id} onChange={(ev) => {
																	handleChange(ev);
																	let rate = getTaxRateByCountry(values.billingCountry)
																	this.onSelectChange(ev.target.value, setFieldValue, rate);
																}} 
																checked={values.passType === ptd.id} data-pass-value={ptd.value} />
														</Col>)
														}
													)
												}
													</Row>

												{errors.passType &&
												touched.passType && (
													<div className="input-feedback">{errors.passType}</div>
												)}
											</Col>
										</Row>
										
										
										<h2 className="mt-5">{t('sections.paymentDetails.title')}</h2>
										<h3 className="mt-5">{t('sections.cardHolderDetails.title')}</h3>
										
										<Row className="mt-3 justify-content-md-center">
											<Col xs={12} md={4}>
											<div className="field">
												<input
													id="billingAddress"
													placeholder={t('fields.billingAddress.placeholder')}
													type="text"
													value={values.billingAddress}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.billingAddress && touched.billingAddress ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
													<label htmlFor="billingAddress" style={{ display: 'block' }}>
													{t('fields.billingAddress.label')}*
												</label>
												</div>
												{errors.billingAddress &&
												touched.billingAddress && (
													<div className="input-feedback">{errors.billingAddress}</div>
												)}
											</Col>
											<Col xs={12} md={4}>
											<div className="field">
												<input
													id="billingCity"
													placeholder={t('fields.billingCity.placeholder')}
													type="text"
													value={values.billingCity}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.billingCity && touched.billingCity ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="billingCity" style={{ display: 'block' }}>
												{t('fields.billingCity.label')}*
												</label>
												</div>
												{errors.billingCity &&
												touched.billingCity && (
													<div className="input-feedback">{errors.billingCity}</div>
												)}
											</Col>
											<Col xs={12} md={4}>
											<div className="field">
												<Field
													as="select"
													name="billingCountry"
													value={values.billingCountry}
													onChange={(ev) => {
														handleChange(ev);
														let rate = getTaxRateByCountry(ev.target.value)
														this.onSelectChange(values.passType, setFieldValue, rate);
														setFieldValue('billingState', "", false);
													}}
													onBlur={handleBlur}
													style={{ display: 'block' }}
													className={
														errors.billingCountry && touched.billingCountry ? (
															'control-select error has-error form-control'
														) : (
															`control-select form-control ${(touched.billingCountry) ? 'touched' : ''}`
															)
														}
													>
														<option value='U/A' defaultValue>{t('fields.billingCountry.label')}</option>
														{AmeliaCountries.map(c => (
															<option key={c.code} value={c.code}>{c.name}</option>
														))}
													</Field>
	
													<label htmlFor="billingCountry" style={{ display: 'block' }}>
														{t('fields.billingCountry.label')}*
													</label>
													</div>

												{errors.billingCountry &&
												touched.billingCountry && (
													<div className="input-feedback">{errors.billingCountry}</div>
												)}
											</Col>
										</Row>

										<Row className="mt-3 justify-content-md-center">
										<Col xs={12} md={4}>
										<div className="field">
												
											{/* 	<input
													id="billingState"
													placeholder={t('fields.billingState.placeholder')}
													type="text"
													value={values.billingState}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.billingState && touched.billingState ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												
												 */}

												<Field
													as="select"
													name="billingState"
													value={values.billingState}
													onChange={(ev) => {
														handleChange(ev);
														/* let rate = getTaxRateByCountry(ev.target.value)
														this.onSelectChange(values.passType, setFieldValue, rate); */
													}}
													onBlur={handleBlur}
													style={{ display: 'block' }}
													className={
														errors.billingState && touched.billingState ? (
															'control-select error has-error form-control'
														) : (
															`control-select form-control ${(touched.billingState) ? 'touched' : ''}`
															)
														}
													>
														<option value="U/A" defaultValue>{t('fields.billingState.label')}</option>
														{(values.billingCountry != 'U/A') ? AmeliaCountries.find(ac => ac.code === values.billingCountry).provinces.map(c => (
															<option key={c.code} value={c.code}>{c.name}</option>
														)): ''}
													</Field>

													<label htmlFor="billingState" style={{ display: 'block' }}>
														{t('fields.billingState.label')}
													</label>
													</div>
												{errors.billingState &&
												touched.billingState && (
													<div className="input-feedback">{errors.billingState}</div>
												)}
											</Col>
											<Col xs={12} md={4}>
											<div className="field">
												
												<input
													id="postalCode"
													placeholder={t('fields.postalCode.placeholder')}
													type="text"
													value={values.postalCode}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.postalCode && touched.postalCode ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="postalCode" style={{ display: 'block' }}>
													{t('fields.postalCode.label')}
												</label>
												</div>
												{errors.postalCode &&
												touched.postalCode && (
													<div className="input-feedback">{errors.postalCode}</div>
												)}
											</Col>
											<Col xs={12} md={4}>
											<div className="field">
												<input
													id="billingPhone"
													placeholder={t('fields.phone.placeholder')}
													type="tel"
													pattern={phoneRegExpHtml}
													value={values.billingPhone}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.billingPhone && touched.billingPhone ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="billingPhone" style={{ display: 'block' }}>
													{t('fields.phone.label')}*
												</label>
												</div>
												{errors.billingPhone &&
												touched.billingPhone && <div className="input-feedback">{errors.billingPhone}</div>}
											</Col>
										</Row>
										
										<h3 className="mt-5">{t('sections.creditCardDetails.title')}</h3>
										<Row className="mt-3 justify-content-md-center">
										<Col xs={12} md={5}>
												<label htmlFor="cardNumber" style={{ display: 'block' }} className="up">
												{t('fields.cardNumber.label')}*
												</label>
												<input
													id="cardNumber"
													placeholder={t('fields.cardNumber.placeholder')}
													type="number"
													pattern="[0-9]*"
													value={values.cardNumber}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.cardNumber && touched.cardNumber ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<div className={'card-types'}>
													<VisaSVG/>
													<McSVG/>
													<AmexSVG/>
													<JcbSVG/>
												</div>
												{errors.cardNumber &&
												touched.cardNumber && (
													<div className="input-feedback">{errors.cardNumber}</div>
												)}
											</Col>
										<Col xs={12} md={3}>
												<label htmlFor="cardHolderName" style={{ display: 'block' }} className="up">
												{t('fields.cardHolderName.label')}*
												</label>
												<input
													id="cardHolderName"
													placeholder={t('fields.cardHolderName.placeholder')}
													type="text"
													value={values.cardHolderName}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.cardHolderName && touched.cardHolderName ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												{errors.cardHolderName &&
												touched.cardHolderName && (
													<div className="input-feedback">{errors.cardHolderName}</div>
												)}
											</Col>
										<Col xs={8} md={3}>
											<label htmlFor="expirationMonth" style={{ display: 'block' }} className="up">
											{t('fields.expirationDate.label')}*
											</label>
											<Row>
												<Col>
													<input
														id="expirationMonth"
														placeholder={t('fields.expirationDate.month.placeholder')}
														type="number"
														pattern="[0-9]*"
														maxLength="2"
														onInput={e => this.focusChange(e)}
														value={values.expirationMonth}
														onChange={handleChange}
														onBlur={handleBlur}
														className={
															errors.expirationMonth && touched.expirationMonth ? (
																'text-input error has-error form-control'
															) : (
																'text-input form-control'
															)
														}
													/>
												</Col>
												<Col>
													<input
														id="expirationYear"
														placeholder={t('fields.expirationDate.year.placeholder')}
														type="number"
														pattern="[0-9]*"
														maxLength="2"
														onInput={e => this.focusChange(e)}
														value={values.expirationYear}
														onChange={handleChange}
														onBlur={handleBlur}
														className={
															errors.expirationYear && touched.expirationYear ? (
																'text-input error has-error form-control'
															) : (
																'text-input form-control'
															)
														}
													/>
												</Col>
											</Row>
											<div>
												{errors.expirationMonth &&
												touched.expirationMonth && (
													<div className="input-feedback">{errors.expirationMonth}</div>
												)}
												{errors.expirationYear &&
												touched.expirationYear && (
													<div className="input-feedback">{errors.expirationYear}</div>
												)}
											</div>
										</Col>
										<Col xs={4} md={1}>
												<label htmlFor="cvv" style={{ display: 'block' }} className="up">
												{t('fields.cvv.label')}*
												</label>
												<input
													id="cvv"
													placeholder={t('fields.cvv.placeholder')}
													type="text"
													inputMode="numeric"
													pattern="[0-9]*"
													maxLength="4"
													value={values.cvv}
													onChange={handleChange}
													onBlur={handleBlur}
													className={
														errors.cvv && touched.cvv ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												{errors.cvv &&
												touched.cvv && <div className="input-feedback">{errors.cvv}</div>}
											</Col>
										</Row>
										
										{!this.state.hideReferralFields ? ( <>
										<h2 className="mt-5">{t('sections.referral.title')}</h2>
										<div className="email-warning">{t('sections.referral.description')}</div>
										<Row className="mt-3 justify-content-md-center">
										<Col>
										<div className="field">
												<input
													id="referredByFullname"
													placeholder={t('fields.referredByFullname.placeholder')}
													autoComplete="off"
													type="text"
													value={values.referredByFullname}
													onChange={handleChange}
													onBlur={handleBlur}
													disabled={(this.state.disableReferralFields) ? true : false}
													className={
														(errors.referredByFullname && touched.referredByFullname) || ((errors.referredByFullname && touched.referredByEmail) || (errors.referredByFullname && touched.referredByPhone)) ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="referredByFullname" style={{ display: 'block' }}>
												{ t('fields.referredByFullname.label') }
												</label>
												</div>
												
												{(errors.referredByFullname && touched.referredByFullname) || ((errors.referredByFullname && touched.referredByEmail) || (errors.referredByFullname && touched.referredByPhone)) ? (
													<div className="input-feedback">{errors.referredByFullname}</div>
												) : ('')}
											</Col>
											<Col>
											<div className="field">
												
												<input
													id="referredByEmail"
													placeholder={t('fields.referredByEmail.placeholder')}
													autoComplete="off"
													type="email"
													value={values.referredByEmail}
													onChange={handleChange}
													onBlur={handleBlur}
													disabled={(this.state.disableReferralFields) ? true : false}
													className={
														errors.referredByEmail && touched.referredByEmail ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="referredByEmail" style={{ display: 'block' }}>
												{t('fields.referredByEmail.label')}
												</label>
												</div>
												{errors.referredByEmail &&
												touched.referredByEmail && (
													<div className="input-feedback">{errors.referredByEmail}</div>
												)}
											</Col>
											<Col>
											<div className="field">
												<input
													id="referredByPhone"
													placeholder={t('fields.referredByPhone.placeholder')}
													autoComplete="off"
													type="tel"
													pattern={phoneRegExpHtml}
													value={values.referredByPhone}
													onChange={handleChange}
													onBlur={handleBlur}
													disabled={(this.state.disableReferralFields) ? true : false}
													className={
														errors.referredByPhone && touched.referredByPhone ? (
															'text-input error has-error form-control'
														) : (
															'text-input form-control'
														)
													}
												/>
												<label htmlFor="referredByPhone" style={{ display: 'block' }}>
													{t('fields.referredByPhone.label')}
												</label>
												</div>
												{errors.referredByPhone &&
												touched.referredByPhone && (
													<div className="input-feedback">{errors.referredByPhone}</div>
												)}
											</Col>
										</Row>
										</>): (
											<input
											id="referredById"
											type="hidden"
											value={values.referredById}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										)}

										<Row className="mt-5 mb-3">
											<Col className="termsx rounded">
												{/* <TandC lang={this.state.lang} /> */}
												{this.state.data && (
													<div dangerouslySetInnerHTML={{__html:this.state.data}} />
												)}
											</Col>
										</Row>
										<Row className="mt-4 mb-4">
											<Col>
												<div className="form-check">
													
													<input
														id="terms"
														type="checkbox"
														value={values.terms}
														onChange={handleChange}
														onBlur={handleBlur}
														className={
															errors.terms && touched.terms ? (
																'form-check-input error'
															) : (
																'form-check-input'
															)
														}
													/>

													<label htmlFor="terms" className={`form-check-label ${
															errors.terms ? (
																'error'
															) : (
																''
															)
														}`}>
													{t('fields.terms.label')}*
													</label>

													{errors.terms &&
													touched.terms && (
														<div className="input-feedback">{errors.terms}</div>
													)}
												</div>
											</Col>
										</Row>
										
										<Row className="mt-3 mb-5 justify-content-start">
											<Col xs={12} sm={10} md={7} className="text-left">
												<Card style={{ width: 'auto' }} className="text-left mb-5 totals">
													<Card.Body>
														<Container>
															<Row>
															<Col><h4>{t('sections.cart.title')}</h4></Col>
															</Row>

															{values.discountTotal != '0' && (
															<>
															<Row className="mb-2">
																<Col>{t('sections.cart.originalPrice')} - {this.passTypeDefinition.find(e => e.id === values.passType).id}</Col>
																<Col className="text-right">{values.originalTotal} VND</Col>
															</Row>
															
															<Row className="mb-2 discount">
																<Col>{t('sections.cart.discountedAmount')} - {values.discountCode.id} - {values.discountCode.percentage}%</Col>
																<Col className="text-right">({values.discountTotal} VND)</Col>
															</Row>
															</>
															)}

															<Row className="mb-2">
																<Col>{t('sections.cart.subTotal')} - {this.passTypeDefinition.find(e => e.id === values.passType).id}</Col>
																<Col className="text-right">{values.subTotal} VND</Col>
															</Row>
															
															<Row className="mb-2">
																<Col>{t('sections.cart.taxTotal')}</Col>
																<Col className="text-right">{values.taxesTotal} VND</Col>
															</Row>
															<Row className="totalRow">
																<Col>{t('sections.cart.total')}</Col>
																<Col className="text-right">{values.paymentTotal} VND</Col>
															</Row>
														</Container>
													</Card.Body>
												</Card>
												{isMobile && (<Row>
													<Col className={'form-error-list text-left mb-3'}>
													{Object.keys(errors).length ? (
														<h3>{t('sections.cart.errorTitle')}</h3>
													): (<></>)}
													{Object.values(errors).map((error,i) => (
															<div key={`error${i}`}>– {error}</div>
														))}
													</Col>
												</Row>)}
												<button className="btn btn-submit" type="submit" disabled={(isSubmitting || Object.keys(errors).length)}>
												{t('fields.submit.label')}
												</button>
											</Col>
										</Row>
									</form>
							 { process.env.NODE_ENV !== 'production' && (
							 <>
							 	<DisplayState {...this.state} />
							 	<DisplayFormikState {...props} />
							</>)}
									<MessageModal
										show={isSubmitting}
										headerLabel={t('modals.loading.paymentProcessing.title')}
										bodyMessage={t('modals.loading.paymentProcessing.description')}
										/* show={true}
										headerLabel={t('modals.loading.paymentProcessing.title')}
										bodyMessage={t('modals.loading.paymentProcessing.description')} */
										onHide={this.toggle.bind(this)}
										allowClose={false}
										t={t}
									/>

									<MessageModal
										show={this.state.success == false ? true : false}
										onHide={this.toggle.bind(this)}
										headerLabel={t(`${this.state.errorMessage}.title`)}
										bodyMessage={t(`${this.state.errorMessage}.description`)}
										/* show={true}
										headerLabel={"awesome title bar"}
										bodyMessage={"LET'S get some long message text going in here to keep things interesting"} */
										allowClose={true}
										closeLabel={t('modals.warnings.closeLabel')}
										t={t}
									/>
								</Container>
							);
						}}
					</Formik>
				) : (
					<SuccessState
						{...this.state.submittedData}
						passType={this.state.submittedData.passType}
						traveler={this.state.traveler}
						userLogonName={this.state.userLogonName}
						serialNumber={this.state.serialNumber}
						t={t}
						lang={this.state.lang}
					/>
				)}
				{ process.env.NODE_ENV !== 'production' && (
							 <>
							 	<DisplayState {...this.state} />
							</>)}
				<PageFooter t={t} />
			</div>
		);
	}
}

export default withRouter(withTranslation('common')(App));
